export default {"src":"/_next/static/media/linkedin.71dbd669.svg","height":32,"width":126};